import { Action, combineReducers, ActionReducerMap, ActionReducer, MetaReducer } from '@ngrx/store';
import { compose } from '@ngrx/core';
import { localStorageSync } from 'ngrx-store-localstorage';

import { DockReducer } from './dock.reducer';
import { FleetReducer } from './fleet.reducer';
import { AuthReducer } from "./auth.reducer";
import { AppState } from '.';

export const reducers: ActionReducerMap<AppState> = {
    auth: AuthReducer,
    docks: DockReducer,
    fleet: FleetReducer,
};

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
    return localStorageSync({ keys: ['auth'], rehydrate: true })(reducer);
}

export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];




// WEBPACK FOOTER //
// ./src/states/app.reducer.ts